import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Input, NgModule, Output, ViewChild } from '@angular/core';
import { ZXingScannerComponent, ZXingScannerModule } from '@zxing/ngx-scanner';
import { Result } from '@zxing/library';
import { filter, map, take } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'kig-scanner',
  templateUrl: './kig-scanner.component.html',
  styleUrls: ['./kig-scanner.component.scss']
})
export class KigScannerComponent implements AfterViewInit {
  @ViewChild('scanner') public zxingScanner: ZXingScannerComponent;

  @Input()
  formats;

  @Input()
  device: MediaDeviceInfo;

  @Input()
  autofocusEnabled = true;

  @Input()
  previewFitMode: 'fill' | 'contain' | 'cover' | 'scale-down' | 'none' = 'cover';

  @Input()
  torch;

  @Output()
  torchCompatible = new EventEmitter<boolean>();

  @Output()
  scanSuccess = new EventEmitter<string>();

  @Output()
  scanFailure = new EventEmitter<void>();

  @Output()
  scanError = new EventEmitter<Error>();

  @Output()
  scanComplete = new EventEmitter<Result>();

  @Output()
  camerasFound = new EventEmitter<MediaDeviceInfo[]>();

  @Output()
  camerasNotFound = new EventEmitter<any>();

  @Output()
  permissionResponse = new EventEmitter<boolean>();

  @Output()
  hasDevices = new EventEmitter<boolean>();

  public constructor() {}

  public ngAfterViewInit(): void {
    this.zxingScanner.camerasFound.pipe(
      filter((i: MediaDeviceInfo[]) => i != null && i.length !== 0),
      take(1),
      map(i => i[0])
    ).subscribe(i => this.device = i);
  }
}

@NgModule({
  declarations: [
    KigScannerComponent
  ],
  exports: [
    KigScannerComponent
  ],
  imports: [
    CommonModule,
    ZXingScannerModule
  ]
})
export class KigScannerModule {
}
